'use client'
import { IData } from '@/@types'
import { IBillPackage } from '@/@types/bill-package'
import { getAxiosErrorMessage } from '@/resources'
import { useQuery } from '@tanstack/react-query'
import api from '../axios'

export function useGetBillPackages() {
  const query = useQuery({
    queryKey: ['/bill-packages'],
    queryFn: async () => {
      try {
        const { data } = await api.get<IData<Array<IBillPackage>>>(`/packages`)

        const packages = data.data?.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
        )

        return packages ?? []
      } catch (error) {
        throw new Error(getAxiosErrorMessage(error))
      }
    },
  })

  return query
}
